module.exports = __webpack_public_path__ + "img/c07_unitstartechspearmanchampion_Normal_ua.6194673b.webp";